/* Rondo custom (r3, 2026-10-08): small behaviours shared by the Rondo sections. Loaded deferred from layout/theme.liquid. */
(function () {
  // Swipe rows (customer reviews): arrows on desktop, shown only when the row overflows.
  function initTrack(root) {
    if (root.dataset.trackReady) return; root.dataset.trackReady = '1';
    var list = root.querySelector('[data-track-list]'); if (!list) return;
    var prev = root.querySelector('[data-track-dir="-1"]'), next = root.querySelector('[data-track-dir="1"]');
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var show = max > 4 && window.matchMedia('(min-width: 769px)').matches;
      [prev, next].forEach(function (b) { if (b) b.hidden = !show; });
      if (prev) prev.disabled = list.scrollLeft <= 4;
      if (next) next.disabled = list.scrollLeft >= max - 4;
    }
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var card = list.firstElementChild; var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        var step = card ? card.getBoundingClientRect().width + gap : list.clientWidth;
        list.scrollBy({ left: step * Number(b.dataset.trackDir), behavior: 'smooth' });
      });
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Product gallery on phones: muted MP4 plays inline while on screen; the sound button unmutes and shows controls.
  function initPhoneVideo(box) {
    if (box.dataset.pvReady) return; box.dataset.pvReady = '1';
    var v = box.querySelector('video'); if (!v) return;
    v.muted = true; v.defaultMuted = true;
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) play(); else v.pause(); });
      }, { threshold: [0, 0.5] }).observe(box);
    } else { play(); }
    var btn = box.querySelector('[data-rondo-pv-sound]');
    if (btn) btn.addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      v.muted = false; v.controls = true; box.classList.add('is-sound'); play();
    });
  }

  // Mouse drag on the swipe rows (touch already swipes natively). Lets desktop visitors and the theme editor's
  // phone preview drag the reviews / video rows; a drag never counts as a click (video tap = fullscreen).
  function initDrag(list) {
    if (list.dataset.dragReady) return; list.dataset.dragReady = '1';
    var startX = 0, startLeft = 0, down = false, moved = false;
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || list.scrollWidth <= list.clientWidth) return;
      down = true; moved = false; startX = e.clientX; startLeft = list.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) { moved = true; list.classList.add('is-dragging'); }
      list.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (!moved) return;
      // Settle on the nearest card, then hand snapping back to CSS.
      var cards = list.children, best = 0, bestD = Infinity, base = list.getBoundingClientRect().left;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - base);
        if (d < bestD) { bestD = d; best = i; }
      }
      var target = cards[best] ? list.scrollLeft + cards[best].getBoundingClientRect().left - base : list.scrollLeft;
      list.classList.remove('is-dragging');
      list.scrollTo({ left: target, behavior: 'smooth' });
    });
    list.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rondo-track]').forEach(initTrack);
    (scope || document).querySelectorAll('[data-track-list], .rondo-videos__track').forEach(initDrag);
    (scope || document).querySelectorAll('[data-rondo-pv]').forEach(initPhoneVideo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
